import dayjs from "dayjs";

function getHourDiff(time, format = "YYYY-MM-DD HH:mm:ss", diffIn = "hours") {
  try {
    if (!time) {
      throw new Error(
        "Time parameter is required to calculate hour difference"
      );
    }
    const dayjsTime = format ? dayjs(time, format) : dayjs(time);
    const hourDifference = dayjs(dayjsTime).diff(dayjs(), diffIn);
    if (isNaN(hourDifference)) {
      throw new Error("Invalid time or format provided");
    }
    return hourDifference;
  } catch (error) {
    console.error("Error calculating hour difference:", error);
    return null;
  }
}

export { getHourDiff };
